import { NotFound } from "../../not-found";
import withSuspense from "../../hocs/withSuspense";
import { PolicyDetails } from "./PolicyDetails";
import { LoaderWithSkeletons } from "./LoaderWithSkeletons/LoaderWithSkeletons";

export const PolicyDetailsWithSuspense = withSuspense(PolicyDetails, {
  FallbackComponent: NotFound,
  loading: <LoaderWithSkeletons />,
});
